module.exports = __webpack_public_path__ + "b448890ddeeb6d2b6ac90e0f4443e912.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-santa-s.png
// module id = 2286
// module chunks = 0